module.exports = __webpack_public_path__ + "img/main_title.e3268f85.png";